import { useState } from 'react';
import GlowButton from '@/components/base/GlowButton';

const packages = [
  {
    id: 'basic',
    name: 'Basic Listing',
    price: '$29',
    period: '/mo',
    color: 'from-white/70 to-white/50',
    border: 'border-[#c5d9eb]/60',
    badge: null,
    features: ['Community listing', 'Basic analytics', 'Category badge', '1 featured tag'],
  },
  {
    id: 'pro',
    name: 'Pro Spotlight',
    price: '$79',
    period: '/mo',
    color: 'from-[#0088CC]/8 to-[#0066AA]/5',
    border: 'border-[#0088CC]/25',
    badge: 'Popular',
    features: ['Priority placement', 'Featured carousel slot', 'Advanced analytics', 'Custom banner', 'Direct contact badge'],
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    color: 'from-amber-50 to-yellow-50/80',
    border: 'border-amber-200/60',
    badge: 'Best Value',
    features: ['Top banner ads', 'Dedicated account manager', 'API access', 'White-label options', 'Priority support'],
  },
];

const stats = [
  { value: '120K+', label: 'Monthly Visitors' },
  { value: '8.5K+', label: 'Communities' },
  { value: '340+', label: 'Partners' },
];

export default function PartnershipPanel() {
  const [selected, setSelected] = useState<string | null>(null);
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <div className="bg-[#ddeaf5]/75 backdrop-blur-xl rounded-2xl overflow-hidden">
      <div className="px-4 pt-4 pb-3 border-b border-[#b8d4ea]/40">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-shake-hands-line text-[#0088CC] text-base"></i>
          </div>
          <h2 className="text-sm font-bold text-slate-800">Partnership & Advertising</h2>
        </div>
        <p className="text-[11px] text-slate-400 leading-relaxed">
          Reach 120K+ Telegram community seekers every month.
        </p>
      </div>

      <div className="grid grid-cols-3 divide-x divide-[#b8d4ea]/40 border-b border-[#b8d4ea]/40">
        {stats.map((s) => (
          <div key={s.label} className="px-3 py-3 text-center">
            <div className="text-base font-extrabold text-[#0088CC]">{s.value}</div>
            <div className="text-[10px] text-slate-400 mt-0.5 leading-tight">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="p-3 flex flex-col gap-2">
        {packages.map((pkg) => (
          <button
            key={pkg.id}
            onClick={() => setSelected(selected === pkg.id ? null : pkg.id)}
            className={`w-full text-left rounded-xl border bg-gradient-to-br ${pkg.color} ${pkg.border} p-3 transition-all cursor-pointer ${
              selected === pkg.id ? 'ring-1 ring-[#0088CC]/40' : 'hover:border-[#0088CC]/30'
            }`}
          >
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold text-slate-700">{pkg.name}</span>
                {pkg.badge && (
                  <span className="text-[9px] font-bold text-[#0088CC] bg-[#0088CC]/10 px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    {pkg.badge}
                  </span>
                )}
              </div>
              <div className="flex items-baseline gap-0.5">
                <span className="text-base font-extrabold text-slate-800">{pkg.price}</span>
                <span className="text-[10px] text-slate-400">{pkg.period}</span>
              </div>
            </div>
            {selected === pkg.id ? (
              <ul className="mt-2 flex flex-col gap-1">
                {pkg.features.map((f) => (
                  <li key={f} className="flex items-center gap-1.5 text-[11px] text-slate-500">
                    <div className="w-3 h-3 flex items-center justify-center shrink-0">
                      <i className="ri-check-line text-[#0088CC] text-xs"></i>
                    </div>
                    {f}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-[10px] text-slate-400 mt-0.5">{pkg.features[0]} + {pkg.features.length - 1} more</p>
            )}
          </button>
        ))}
      </div>

      <div className="px-3 pb-4 flex flex-col gap-2">
        <GlowButton
          onClick={() => setContactOpen(!contactOpen)}
          className="w-full text-sm font-bold py-2.5 rounded-xl"
        >
          Get Started — Contact Us
        </GlowButton>
        {contactOpen && (
          <div className="bg-white/50 backdrop-blur-md border border-white/80 rounded-xl p-3 text-center">
            <p className="text-[11px] text-slate-400 mb-2.5">Reach our partnership team:</p>
            <a
              href="https://t.me/liketgli"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-1.5 text-xs text-[#0088CC] hover:underline cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-telegram-fill"></i></div>
              @liketgli
            </a>
          </div>
        )}
        <p className="text-[10px] text-slate-400 text-center">Free listing available for new communities</p>
      </div>
    </div>
  );
}
